import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import IssuesFilters from './issuesFilters';
import SearchInput from '../common/search/searchInput';
import Icon from '../common/containers/icon';
const filterEntities = ['jobFilterIssue', 'issueAssignmentFilterIssue', 'issueStatusFilterIssue', 'issueSeverityFilterIssue', 'reportFilterIssue', 'reportTypeFilterIssue', 'creatorFilterIssue'];
const filterEntityState = () => {
  const result = {};
  filterEntities.forEach(entity => {
    result["".concat(entity, "IndexQuery")] = state => state[entity].indexQuery;
    result["".concat(entity, "InitialIndexQuery")] = state => state[entity].initialIndexQuery;
  });
  return result;
};
class IssuesFilterPanel extends Component {
  constructor(props) {
    super(props);
    this.handleFilterClear = this.filterClear.bind(this);
    this.handleChangeText = this.filterText.bind(this);
    this.handleClearText = this.filterText.bind(this, '');
  }
  filterText(textValue) {
    const _this$props = this.props,
      issueIndexQuery = _this$props.issueIndexQuery,
      issueActions = _this$props.issueActions;
    const newFilters = _objectSpread(_objectSpread({}, issueIndexQuery.filters), {}, {
      text: textValue
    });
    issueActions.serverFilter(newFilters, issueIndexQuery);
  }
  filterClear() {
    const _this$props2 = this.props,
      issueInitialIndexQuery = _this$props2.issueInitialIndexQuery,
      issueActions = _this$props2.issueActions;
    issueActions.serverIndex(issueInitialIndexQuery);
    filterEntities.forEach(entity => {
      /* eslint-disable react/destructuring-assignment */
      const entityIndexQuery = this.props["".concat(entity, "IndexQuery")];
      // no need to reset filters that have not yet been loaded
      if (entityIndexQuery.initialized) {
        const entityInitialIndexQuery = this.props["".concat(entity, "InitialIndexQuery")];
        const actions = this.props["".concat(entity, "Actions")];
        actions.serverIndex(entityInitialIndexQuery);
      }
      /* eslint-enable react/destructuring-assignment */
    });
  }
  render() {
    const issueIndexQuery = this.props.issueIndexQuery;
    const filters = issueIndexQuery.filters ? issueIndexQuery.filters : {};
    return /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, /*#__PURE__*/React.createElement("h3", {
      className: "t-ifp-title"
    }, "Filter")), /*#__PURE__*/React.createElement(Col, {
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleFilterClear,
      className: "float-md-right t-if-clear"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "times-circle",
      weight: "far"
    }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
      className: "t-if-search",
      type: "text",
      text: filters.text,
      onChange: this.handleChangeText,
      onClear: this.handleClearText
    }), /*#__PURE__*/React.createElement(IssuesFilters, null))));
  }
}
IssuesFilterPanel.propTypes = {
  issueIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  issueInitialIndexQuery: PropTypes.shape({}).isRequired,
  issueActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    indexByReport: PropTypes.func,
    serverFilter: PropTypes.func
  }).isRequired
};
export { IssuesFilterPanel as TestIssuesFilterPanel };
export default entityComposition(IssuesFilterPanel, [], _objectSpread(_objectSpread({}, filterEntityState()), {}, {
  issueIndexQuery: state => state.issue.indexQuery,
  issueInitialIndexQuery: state => state.issue.initialIndexQuery
}), ['issue'].concat(filterEntities));